// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZS-z","hovered":"_S-z","hoverImage":"aT-z","mainImage":"bT-z","imageNoBackground":"cT-z","fullSizeImage":"dT-z"};